import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import Avatar from 'sharedComponents/Avatar';
import Tag from 'sharedComponents/Tag';
import LoanOfficerPresenter from 'presenters/realEstateAgent/LoanOfficerPresenter';
import Checkbox from 'sharedComponents/Checkbox';

import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer, onActivate, isUpdating } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const isCompanyLogotypePresent = isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer));
  const isActive = LoanOfficerPresenter.active(loanOfficer);
  const apr = LoanOfficerPresenter.readableApr(loanOfficer);
  const responseTime = LoanOfficerPresenter.readableResponseTime(loanOfficer);
  const isAprPresent = isPresent(apr);
  const isResponseTimePresent = isPresent(responseTime);

  const handleChange = ({ target: { checked } }) => {
    const id = LoanOfficerPresenter.loanOfficerId(loanOfficer);
    onActivate(id, checked);
  };

  return (
    <div className={classes.container}>
      <div className={classes.mainBox}>
        <Checkbox checked={isActive} onChange={handleChange} disabled={isUpdating} />
        <Avatar size="m" className={classes.avatar} imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <div className={classes.loanOfficerBadge}>
          <Typography noWrap variant="subtitle1" color="secondary">
            {t('models.App.userTypes.loanOfficer')}
          </Typography>
          <Typography noWrap variant="h3" className={classes.name}>
            {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
          </Typography>
        </div>
        {isDesktop && (
          <Fragment>
            <div className={classes.loanOfficerInfo}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.RealEstateAgentDashboard.FavoriteLoanOfficersList.LoanOfficerCard.nmls')}
              </Typography>
              <Typography noWrap variant="h3" color="inherit" className={classes.label}>
                {LoanOfficerPresenter.nmls(loanOfficer)}
              </Typography>
            </div>
            <div className={classes.tags}>
              {isAprPresent && (
                <Tag className={classes.tag} color="red">
                  <Typography
                    noWrap
                    variant="subtitle1"
                    dangerouslySetInnerHTML={{
                      __html: t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.apr', {
                        apr,
                      }),
                    }}
                  />
                </Tag>
              )}
              {isResponseTimePresent && (
                <Tag className={classes.tag}>
                  <Typography
                    noWrap
                    variant="subtitle1"
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.responseTime',
                        { responseTime },
                      ),
                    }}
                  />
                </Tag>
              )}
            </div>
          </Fragment>
        )}
      </div>
      {isDesktop && (
        <div className={classes.infoBox}>
          {isCompanyLogotypePresent && (
            <img
              alt="company logo"
              src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
              className={classes.companyLogo}
            />
          )}
          <div className={classes.locationBadge}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.RealEstateAgentDashboard.FavoriteLoanOfficersList.LoanOfficerCard.branchLocation')}
            </Typography>
            <Typography noWrap variant="h3" color="inherit" className={classes.label}>
              {LoanOfficerPresenter.branchLocation(loanOfficer)}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  onActivate: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/components/FavoriteLoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js